var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("emc-table-items", {
        attrs: {
          headers: _vm.headers,
          params: _vm.params,
          collections: _vm.items,
          meta: _vm.meta,
          itemEdit: _vm.itemSelected,
          loading: _vm.loading,
          find: false,
          showDelete: false,
          hideEdit: true,
        },
        on: {
          "update:params": function ($event) {
            _vm.params = $event
          },
          "update:collections": function ($event) {
            _vm.items = $event
          },
          "update:meta": function ($event) {
            _vm.meta = $event
          },
          "update:itemEdit": function ($event) {
            _vm.itemSelected = $event
          },
          "update:item-edit": function ($event) {
            _vm.itemSelected = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.signed_at",
            fn: function ({ item }) {
              return [
                item.term_signature_status_id == 2
                  ? _c("span", [
                      _vm._v(_vm._s(_vm._f("dateTime")(item.updated_at))),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.situation",
            fn: function ({ item }) {
              return [
                _vm._v(" " + _vm._s(item.status.name) + " "),
                item.term_signature_status_id != 1
                  ? _c("small", [
                      _c("br"),
                      item.term.is_required
                        ? _c("span", [
                            item.agree
                              ? _c("span", [_vm._v(_vm._s(item.term.label))])
                              : _vm._e(),
                          ])
                        : _c("span", [
                            item.option
                              ? _c("span", [_vm._v(_vm._s(item.option.label))])
                              : _vm._e(),
                          ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.digital_signature_info",
            fn: function ({ item }) {
              return [
                _c("sys-term-digital-signature-status", {
                  attrs: {
                    status: item.digital_signature_status,
                    "x-small": "",
                  },
                }),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ item }) {
              return [
                item.term_signature_status_id != 1
                  ? _c("emc-table-icon-download-pdf", {
                      attrs: {
                        toolTip: "Download do Termo",
                        route: _vm.token
                          ? "teachers/token/" +
                            _vm.token +
                            "/" +
                            item.id +
                            "/pdf-download/teacher-term-signature"
                          : null,
                        type: "teacher-term-signature",
                        token: _vm.token,
                        item: item,
                        disabled:
                          item.term_signature_status == 1 || !item.url_document,
                      },
                    })
                  : _vm._e(),
                _c("emc-table-icon-edit", {
                  attrs: {
                    "tool-tip": _vm.canSign(item)
                      ? "Assinar Termo"
                      : "Visualizar Termo",
                    color: _vm.canSign(item) ? "success" : "purple",
                    icon: _vm.canSign(item)
                      ? "mdi-file-document-edit"
                      : "mdi-text-box-search-outline",
                  },
                  on: {
                    click: function ($event) {
                      _vm.itemSelected = item
                      _vm.showForm = true
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("sys-register-term-signature-form", {
        attrs: {
          view: !_vm.canSign(_vm.itemSelected),
          show: _vm.showForm,
          token: _vm.token,
          "signature-id": _vm.itemSelected.id,
        },
        on: {
          "update:show": function ($event) {
            _vm.showForm = $event
          },
          onCompleted: function ($event) {
            return _vm.getData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }